module.exports = __webpack_public_path__ + "static/media/quote1.44a935cd.svg";